module.exports = "/_next/static/images/subcontractingOpportunities-e6f6cc84c6f6c2febb9ff9d76b9f0e89.webp";